import { Select } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadLightUsers } from 'shared/hooks/use-load-light-users';

interface AccountManagerSelectorProps {
  value: string | null;
  onChange: (value: string | null) => void;
  loadInactive?: boolean;
}

export const AccountManagerSelector = ({
  value,
  onChange,
  loadInactive = false,
}: AccountManagerSelectorProps) => {
  const { t } = useTranslation();
  const { users = [] } = useLoadLightUsers(loadInactive);

  const data = users.map(({ id, name: userName }) => ({
    value: String(id),
    label: userName.full,
  }));

  return (
    <Select
      label={t(i18nKeys.ACCOUNT_MANAGER)}
      placeholder={t(i18nKeys.DASHBOARD.SELECT_ACCOUNT_MANAGER)}
      data={data}
      value={value}
      onChange={onChange}
      searchable
      clearable
    />
  );
};
